import useDocuments from './useDocuments';

export { useDocuments };
